import React from "react";
import awardList from "./common/awardList";
import Title from "./common/Title";
import Slider from "./common/slider/Slider";
import { makeStyles, Link } from "@material-ui/core";

export default function Awards() {
  const useStyles = makeStyles((theme) => ({
    img: {
      width: "100%",
      height: "100px",
      objectFit: "cover",
    },
  }));
  const classes = useStyles();

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    timeout: 4000,
    breakpoints: {
      xs: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      sm: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
      md: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
      lg: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
  };

  return (
    <>
      <Title
        title="Our Awards"
        description="NaTakallam is the proud recipient of the following awards."
      />
      <Slider {...settings}>
        {awardList.map((award) => (
          <Link href={award.link} key={award.imgPath}>
            <img
              className={classes.img}
              src={award.imgPath}
              alt={award.label}
            />
          </Link>
        ))}
      </Slider>
    </>
  );
}
